import type { ReactNode } from "react";

import { SiteFooter } from "@/components/SiteFooter";
import { Link } from "@/router";

/**
 * Where a form submitted *without JavaScript* lands.
 *
 * With JavaScript the contact form never leaves the page — it swaps itself
 * for the confirmation in place, exactly as it always has. These pages exist
 * only for the no-JS path, where the browser performs a real POST and the
 * Worker has to redirect somewhere afterwards.
 *
 * They are ordinary prerendered routes rather than HTML assembled in the
 * Worker, which keeps the Worker free of markup and means the confirmation is
 * styled by the same stylesheet as everything else instead of by a second,
 * quietly diverging copy of it.
 */
export function Outcome({
  chip,
  chipTone,
  title,
  children,
}: {
  chip: string;
  chipTone: "green" | "red";
  title: string;
  children: ReactNode;
}) {
  return (
    <main>
      <section className="k-shell k-sec">
        <div
          className={
            chipTone === "green" ? "k-sent" : "k-sent k-sent--trouble"
          }
        >
          <span className={`k-chip k-chip--${chipTone}`}>{chip}</span>
          <h1>{title}</h1>
          {children}
          <Link className="k-btn" href="/">
            Back to the home page
          </Link>
        </div>
      </section>

      <SiteFooter />
    </main>
  );
}
